export const intBetween = (lowInclusive, highExclusive) => Math.floor(
  Math.random() * (highExclusive - lowInclusive)
) + lowInclusive



// WEBPACK FOOTER //
// ./src/random.js